import type { Block } from '../../../../types/proposal-blocks';

type Data = Extract<Block, { type: 'comparison_table' }>;

export function ComparisonTableBlock({ block }: { block: Data }) {
  return (
    <div className="my-6">
      <div className="overflow-x-auto border border-proposal-border rounded-p-lg">
        <table className="w-full border-collapse text-[13px]">
          <thead>
            <tr>
              <th className="bg-proposal-bg2 text-proposal-fg3 text-[11px] font-semibold uppercase tracking-wide px-4 py-3 text-left border-b border-proposal-border border-r border-proposal-border w-[200px]" />
              {block.columns.map((col) => (
                <th
                  key={col.id}
                  className={`text-[11px] font-semibold uppercase tracking-wide px-4 py-3 text-left border-b border-proposal-border border-r border-proposal-border last:border-r-0 ${
                    col.recommended
                      ? 'bg-proposal-accent-dim border-t-2 border-t-proposal-accent text-proposal-fg1'
                      : 'bg-proposal-bg2 text-proposal-fg3'
                  }`}
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {block.rows.map((row, ri) => (
              <tr key={ri} className="hover:bg-proposal-bg2/50">
                <td className="font-semibold text-[12px] text-proposal-fg2 uppercase tracking-wide px-4 py-3 border-b border-proposal-border border-r border-proposal-border">
                  {row.label}
                </td>
                {row.values.map((val, ci) => {
                  const isRec = block.columns[ci]?.recommended;
                  const display = typeof val === 'boolean' ? (val ? '✓' : '–') : String(val);
                  return (
                    <td
                      key={ci}
                      className={`px-4 py-3 border-b border-proposal-border border-r border-proposal-border last:border-r-0 ${isRec ? 'bg-proposal-accent-dim' : ''}`}
                    >
                      {display === '✓' ? <span className="text-proposal-accent text-[15px]">✓</span>
                        : display === '–' ? <span className="text-proposal-fg3 text-[15px]">–</span>
                        : <span>{display}</span>}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {block.footnote && (
        <div className="bg-proposal-accent-dim border-l-[3px] border-l-proposal-accent rounded-r-p-md px-4 py-3.5 mt-4 text-[13px] text-proposal-fg2 leading-relaxed">
          <strong className="text-proposal-fg1">Nota:</strong> {block.footnote}
        </div>
      )}
    </div>
  );
}
